export const handleAuthenticationInterceptor = (request) => {
  const jwtToken = localStorage.getItem('jwtToken');
  if (jwtToken) {
    request.headers = request.headers || {};
    request.headers['x-auth-token'] = jwtToken;
  }

  return request;
};
